import { AppBar, Box, Button, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedSnackbar,
	LabelPosition,
	RHookFormNumberField,
	RHookFormNumberFieldWithLabel,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import {
	EHT_ONTARIO_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	formatAmountCommaSeperator,
	formatDate,
	formatThousandSeperatorWithTwoFixedAmount,
	sortDDLByLabel,
	useNavigateToLogout,
} from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { ClientService } from "../../services";
import { CountryService } from "../../services/common/CountryService";
import FileSaver from "file-saver";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { IOntarioEht } from "../../models/OntarioEht";
import { OntarioEhtDataGrid } from "./OntarioEhtDataGrid";
import { OntarioEhtDataGridWithManagedBySimplePay } from "./OntarioEhtDataGrid/OntarioEhtDataGridWithManagedBySimplePay";
import { OntarioEhtService } from "../../services/OntarioEhtService";
import { PrimeDataGridWithColumnToggled } from "../PrimeDataGridWithColumnToggled";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";

// import { CountryService } from "../../services/CountryService";

export interface IOntarioEhtSetup { }

const useOntarioEhtSavedFrequency = (
	clientId: string,
	taxYear: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["eht-ontario-saved-frequency"],
		queryFn: (data) => {

			return OntarioEhtService.getOntarioEhtSavedFrequency(
				clientId,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useEHTRemittanceSettingGetById = (
	clientId: string,
	taxYear: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["eht-remittance-setting-id"],
		queryFn: (data) => {

			return OntarioEhtService.getEHTRemittanceSetting(
				clientId,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetRemittanceFrequencyDDL = () =>
	useQuery({
		queryKey: ["remittance-Frequency-ddl"],
		queryFn: (data) => {
			return OntarioEhtService.getRemittanceFrequencyDDL();
		},
		refetchOnWindowFocus: false,
	});

const EHT_ONTARIO_LIST_QUERY_KEY = "eht-ontario-list";

const useOntarioEhts = (
	clientId: string,
	remittanceFrequencyId: string | undefined,
	taxYear: number,
	managedBy: number,
	// params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			EHT_ONTARIO_LIST_QUERY_KEY,
			clientId,
			remittanceFrequencyId,
			taxYear,
			managedBy,
		],
		queryFn: (data) => {

			return OntarioEhtService.getOntarioEht(
				clientId,
				remittanceFrequencyId,
				taxYear,
				managedBy,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});


const CLIENT_INFO_DATA_QUERY_KEY = "client-info-data-record";
const useGetClientInformationById = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [CLIENT_INFO_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: (data) => {
			return ClientService.getSimpleClientById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

export const OntarioEhtSetup: React.FC<IOntarioEhtSetup> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	// const companyInformation = useSelector((state: IAppState) => state.dashboardApisData.client_detail)
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [ontarioEhtSetupTableData, setOntarioEhtSetupTableData] = useState([]);
	const [remittanceFrequencyId, setRemittanceFrequencyId] = useState(undefined);
	const [managedBy, setManagedBy] = useState(200);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadinData, setIsLoadinData] = useState(false);

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	// const remittanceFrequencyIdField = formMethods.getValues(
	// 	"remittanceFrequencyId"
	// );
	// const managedByField = formMethods.getValues("managedBy");
	// useEffect(() => {
	// 	if (remittanceFrequencyIdField && managedByField) {
	// 		setRemittanceFrequencyId(remittanceFrequencyIdField);
	// 		setManagedBy(managedByField);
	// 	}
	// }, [remittanceFrequencyIdField, managedByField]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending: isPendingClientInformationById, data: companyInformation } = useGetClientInformationById(
		clientIdStore,
		navigateToLogout
	);
	const {
		isPending: isPendingOntarioEhtSavedFrequency,
		data: ontarioEhtSavedFrequency,
	}: any = useOntarioEhtSavedFrequency(
		clientIdStore,
		taxYear,
		navigateToLogout
	);

	const { isPending: isPendingEHTRemittanceSettingById, data: selectedDataRecordEHTRemittanceSetting } = useEHTRemittanceSettingGetById(
		clientIdStore,
		taxYear,
		navigateToLogout
	);

	// useEffect(() => {
	// 	if (
	// 		ontarioEhtSavedFrequency &&
	// 		ontarioEhtSavedFrequency.frequencies !== null
	// 	) {
	// 		formMethods.setValue(
	// 			"remittanceFrequencyId",
	// 			ontarioEhtSavedFrequency.frequencies
	// 		);
	// 		setRemittanceFrequencyId(ontarioEhtSavedFrequency.frequencies); 
	// 	}
	// }, [ontarioEhtSavedFrequency]);

	useEffect(() => {
		// if (craRamittanceSavedFrequency && craRamittanceSavedFrequency.frequencies !== null) {
		if (ontarioEhtSavedFrequency) {
			formMethods.setValue(
				"remittanceFrequencyId",
				ontarioEhtSavedFrequency.frequencies
			);
			setRemittanceFrequencyId(ontarioEhtSavedFrequency.frequencies);
			formMethods.setValue(
				"managedBy",
				ontarioEhtSavedFrequency.managedBy
			);
			setManagedBy(ontarioEhtSavedFrequency.managedBy);

		}
	}, [ontarioEhtSavedFrequency]);

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, isFetching, data } = useOntarioEhts(
		clientIdStore,
		remittanceFrequencyId,
		taxYear,
		managedBy,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const ontarioEhtSetup: any | null = data;

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	const {
		isPending: isPendingRemittanceFrequencyDDL,
		data: remittanceFrequencyDDL,
	} = useGetRemittanceFrequencyDDL();

	const updatedRemittanceFrequencyDDL = useMemo(() => {
		if (!remittanceFrequencyDDL) return [];

		return remittanceFrequencyDDL.filter((item: any) =>
			item.label === "Regular" || item.label === "Annual"
		);
	}, [remittanceFrequencyDDL]);

	const { isPending: isSubmitting, mutate: submitOntarioEht } = useMutation({
		mutationFn: OntarioEhtService.create,

		onSuccess: (res: IOntarioEht | IServerError | IResponse | any) => {


			if (res && res.status === 200) {
				queryClient.invalidateQueries({
					queryKey: [EHT_ONTARIO_LIST_QUERY_KEY],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroOntarioEht, setzeroOntarioEht] = useState(true);
	const [ontarioEhtSetupUpdatedItems, setOntarioEhtSetupUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [ontarioEhtRowData, setOntarioEhtRowData] = useState<any>(0);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroOntarioEht(false);
	};

	const { isPending: isDeleting, mutate: deleteOntarioEhtById } = useMutation({
		mutationFn: OntarioEhtService.delOntarioEht,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the OntarioEht fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			return queryClient.invalidateQueries({
				queryKey: [EHT_ONTARIO_LIST_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteDepartmentsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				ontarioEhtRowData: ontarioEhtRowData,
				navigateToLogout: navigateToLogout,
			};
			deleteOntarioEhtById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setOntarioEhtRowData(params);
	}, []);

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/ontarioEht/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				// <Box sx={{ marginTop: theme.spacing(1) }}>
				// 	<Button
				// 		onClick={() => onRowMultipleDeleteClicked(selectedItems)}
				// 		variant="contained"
				// 		color="error"
				// 	>
				// 		Delete
				// 	</Button>
				// </Box>
				<></>
			);
		}
		return (
			// <Box sx={{ marginTop: theme.spacing(1) }}>
			// 	<RouterLinkButton to="/ontarioEht/setup" text="Add OntarioEht" />
			// </Box>
			<></>
		);
	}, []);
	const upadtedOntarioEhtSetupItems = useMemo(() => {
		if (ontarioEhtSetup && ontarioEhtSetup.items) {
			const items = [...ontarioEhtSetup.items];

			// Find the last item with a non-null remitAmount using binary search
			let left = 0;
			let right = items.length - 1;
			let lastRemittedIndex = -1;

			while (left <= right) {
				let mid = Math.floor((left + right) / 2);
				if (items[mid].remitAmount != null) {
					lastRemittedIndex = mid;
					left = mid + 1; // look for later remitted value
				} else {
					right = mid - 1;
				}
			}

			// Find the first null remitAmount AFTER the last remitted one
			let nextNullIndex = -1;
			for (let i = lastRemittedIndex + 1; i < items.length; i++) {
				if (items[i].remitAmount == null) {
					nextNullIndex = i;
					break;
				}
			}
			// Map and add the two tags
			return items.map((item, index) => ({
				...item,
				// canDelete:
				// 	items[0].remitAmount === null ? false : index === lastRemittedIndex,
				// canEdit: items[0].remitAmount === null ? true : index === nextNullIndex,
				canDelete: index === lastRemittedIndex,
				canEdit: index === nextNullIndex,
				// gross: formatAmountCommaSeperator(item.gross),
				// exempted: formatAmountCommaSeperator(item.exempted),
				// adjAmount: formatAmountCommaSeperator(item.adjAmount),
				// taxableGross: formatAmountCommaSeperator(item.taxableGross),


			}));
		}
	}, [ontarioEhtSetup]);



	const expandedLabels = ["Taxes", "EHT"];
	const expandedOntarioEhtSetupOrSetupItem = "Ontario"; // Special case for "List" under "OntarioEht"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Taxes" &&
				item.label === expandedOntarioEhtSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedOntarioEhtSetupOrSetupItem && "/taxes/eht/ontario",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EHT_ONTARIO_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);


	const onSaveButtonClickedHandler = async () => {
		const [associatedEmployers, exemptionAmount, totalGrossPaidInYear] = formMethods.watch([
			"associatedEmployers",
			"exemptionAmount",
			"totalGrossPaidInYear",
		]);
		let payload = {
			clientId: clientIdStore,
			taxYear: taxYear,
			navigateToLogout: navigateToLogout,
			exemptionAmount: exemptionAmount ? exemptionAmount : 0,
			totalGrossPaidInYear: totalGrossPaidInYear ? totalGrossPaidInYear : 0,
			associatedEmployers: associatedEmployers,
		};
		(async () => {
			try {
				const responce = await OntarioEhtService.createEHTRemittanceSetting(payload);
			} catch {
			} finally {
				queryClient.invalidateQueries({
					queryKey: ["eht-remittance-setting-id"],
				});
				queryClient.invalidateQueries({
					queryKey: [
						EHT_ONTARIO_LIST_QUERY_KEY,
						clientIdStore,
						remittanceFrequencyId,
						taxYear,
						managedBy,
					],
				});
			}
		})();
	};

	useEffect(() => {
		if (clientIdStore && selectedDataRecordEHTRemittanceSetting) {

			Object.keys(selectedDataRecordEHTRemittanceSetting).forEach((fieldName) => {
				const fieldValue = selectedDataRecordEHTRemittanceSetting[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "totalGrossPaidInYear") {
					formMethods.setValue("totalGrossPaidInYear", String(fieldValue));
				} if (fieldName === "exemptionAmount") {
					formMethods.setValue("exemptionAmount", String(fieldValue));
				}
			});
		}
	}, [clientIdStore, selectedDataRecordEHTRemittanceSetting]);

	const onSubmitButtonClickedHandler = async () => {
		const [remittanceFrequencyId, exemptionAmount, totalGrossPaidInYear, associatedEmployers, managedBy] = formMethods.watch([
			"remittanceFrequencyId",
			"exemptionAmount",
			"totalGrossPaidInYear",
			"associatedEmployers",
			"managedBy",
		]);
		if (remittanceFrequencyId && remittanceFrequencyId !== null) {
			let payload = {
				clientId: clientIdStore,
				taxYear: taxYear,
				navigateToLogout: navigateToLogout,
				exemptionAmount: exemptionAmount,
				totalGrossPaidInYear: totalGrossPaidInYear,
				associatedEmployers: associatedEmployers,
				remittanceFrequencyId: remittanceFrequencyId,
				managedBy: managedBy
			};
			(async () => {
				try {
					const responce = await OntarioEhtService.createEHTRemittanceSetting(payload);
				} catch {
				} finally {
					queryClient.invalidateQueries({
						queryKey: ["eht-remittance-setting-id"],
					});
					queryClient.invalidateQueries({
						queryKey: [
							EHT_ONTARIO_LIST_QUERY_KEY,
							clientIdStore,
							remittanceFrequencyId,
							taxYear,
							managedBy,
						],
					});
				}
			})();
		} else {
			setSnackbarData({
				open: true,
				message: "Frequency is required",
				severity: "error"
			})
		}

	};

	const onSubmit = () => {

		const updatePayloadData =
			ontarioEhtSetupTableData &&
			ontarioEhtSetupTableData.map((item: any) => ({
				...item,
				chequeDate: formatDate(item.chequeDate),
			}));

		const EditedRowData = updatePayloadData.filter((item: any) => item.canEdit);
		submitOntarioEht({ data: [EditedRowData[0]] });
	};

	const onRemittanceFrequencyChangeHandler = async (selectedItem: any) => {
		const [exemptionAmount, totalGrossPaidInYear, associatedEmployers, managedBy] = formMethods.watch([
			"exemptionAmount",
			"totalGrossPaidInYear",
			"associatedEmployers",
			"managedBy",
		]);
		let payload = {
			clientId: clientIdStore,
			taxYear: taxYear,
			navigateToLogout: navigateToLogout,
			exemptionAmount: exemptionAmount,
			totalGrossPaidInYear: totalGrossPaidInYear,
			associatedEmployers: associatedEmployers,
			remittanceFrequencyId: selectedItem.value,
			managedBy: managedBy
		}
		if (
			ontarioEhtSavedFrequency &&
			ontarioEhtSavedFrequency.frequencies === null
		) {
			(async () => {
				setIsLoading(true)
				try {
					const responce = await OntarioEhtService.createOntarioEhtFrequency(payload);

				} catch {

				} finally {
					queryClient.invalidateQueries({
						queryKey: ["eht-ontario-saved-frequency"],
					});
					setRemittanceFrequencyId(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							EHT_ONTARIO_LIST_QUERY_KEY,
							clientIdStore,
							selectedItem.value,
							taxYear,
							managedBy,
						],
					});
					setIsLoading(false)
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		} else if (selectedItem.value) {
			// setRemittanceFrequencyId(selectedItem.value);
			// queryClient.invalidateQueries({
			// 	queryKey: [
			// 		EHT_ONTARIO_LIST_QUERY_KEY,
			// 		clientIdStore,
			// 		selectedItem.value,
			// 		managedBy,
			// 		taxYear,
			// 	],
			// });
			(async () => {
				setIsLoading(true)
				try {
					// const responce = await OntarioEhtService.createOntarioEhtFrequency(
					// 	clientIdStore,
					// 	selectedItem.value,
					// 	managedBy,
					// 	taxYear,
					// 	navigateToLogout
					// );
					const responce = await OntarioEhtService.createOntarioEhtFrequency(payload);


				} catch {

				} finally {
					setIsLoading(false)
					setRemittanceFrequencyId(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							EHT_ONTARIO_LIST_QUERY_KEY,
							clientIdStore,
							selectedItem.value,
							taxYear,
							managedBy,
						],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		}
	};
	const onManagedByChangeHandler = (selectedItem: any) => {
		// setManagedBy(selectedItem.value);
		// queryClient.invalidateQueries({
		// 	queryKey: [
		// 		EHT_ONTARIO_LIST_QUERY_KEY,
		// 		clientIdStore,
		// 		remittanceFrequencyId,
		// 		selectedItem.value,
		// 		taxYear,
		// 	],
		// });
		const [exemptionAmount, totalGrossPaidInYear, associatedEmployers, remittanceFrequencyId] = formMethods.watch([
			"exemptionAmount",
			"totalGrossPaidInYear",
			"associatedEmployers",
			"remittanceFrequencyId",
		]);
		let payload = {
			clientId: clientIdStore,
			taxYear: taxYear,
			navigateToLogout: navigateToLogout,
			exemptionAmount: exemptionAmount,
			totalGrossPaidInYear: totalGrossPaidInYear,
			associatedEmployers: associatedEmployers,
			remittanceFrequencyId: remittanceFrequencyId,
			managedBy: selectedItem.value
		}
		if (
			ontarioEhtSavedFrequency &&
			ontarioEhtSavedFrequency.managedBy === null
		) {
			(async () => {
				setIsLoading(true)
				try {
					const responce = await OntarioEhtService.createOntarioEhtFrequency(payload);

				} catch {

				} finally {
					queryClient.invalidateQueries({
						queryKey: ["eht-ontario-saved-frequency"],
					});
					setManagedBy(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							EHT_ONTARIO_LIST_QUERY_KEY,
							clientIdStore,
							remittanceFrequencyId,
							taxYear,
							selectedItem.value,
						],
					});
					setIsLoading(false)
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		} else if (selectedItem.value) {
			// setRemittanceFrequencyId(selectedItem.value);
			// queryClient.invalidateQueries({
			// 	queryKey: [
			// 		EHT_ONTARIO_LIST_QUERY_KEY,
			// 		clientIdStore,
			// 		selectedItem.value,
			// 		managedBy,
			// 		taxYear,
			// 	],
			// });
			(async () => {
				setIsLoading(true)
				try {
					// const responce = await OntarioEhtService.createOntarioEhtFrequency(
					// 	clientIdStore,
					// 	selectedItem.value,
					// 	managedBy,
					// 	taxYear,
					// 	navigateToLogout
					// );
					const responce = await OntarioEhtService.createOntarioEhtFrequency(payload);


				} catch {

				} finally {
					setIsLoading(false)
					setManagedBy(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							EHT_ONTARIO_LIST_QUERY_KEY,
							clientIdStore,
							remittanceFrequencyId,
							taxYear,
							selectedItem.value,
						],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		}
	};

	const balanceAmount = (value: number) => {
		if (value < 0) {
			return (
				<>
					<span style={{ color: "red" }}>
						{formatThousandSeperatorWithTwoFixedAmount(value)}
					</span>
				</>
			);
		} else {
			return <span>{formatThousandSeperatorWithTwoFixedAmount(value)}</span>;
		}
	};

	// getting latest updated values of form fields using watch method
	const { watch } = formMethods;
	const values = watch([
		"remittanceFrequencyId",
		"managedBy",
	]);

	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async () => {
		const [remittanceFrequencyId, managedBy] = values;

		try {
			setIsLoading(true);
			const response = await OntarioEhtService.exportEHTOntarioRemittanceExcelReport(
				clientIdStore,
				remittanceFrequencyId,
				taxYear,
				managedBy,
			);

			if (response) {
				if (response.status === 400) {
					setSnackbarData({
						open: true,
						message: response.data.message
							? response.data.message
							: "Something went wrong.",

						severity: "error",
					});
				} else {
					const filename = `EHTOntario-Remittance.xlsx`;
					savePdfAsFile(response, filename);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_ontarioEht_list.png";

	return (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					mt: "1rem"
				}}>
				<BackdropCircularProgress
					open={
						isPending || isFetching ||
						isPendingRemittanceFrequencyDDL ||
						isSubmitting ||
						isPendingOntarioEhtSavedFrequency || isPendingClientInformationById || isLoading || isLoadinData || isPendingEHTRemittanceSettingById
					}
					testId="ontarioEht-list"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteDepartmentsField}
					cancelActionHandler={onCloseHandler}
					testId="departments-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<Grid
							container
							size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
							sx={{
								background: "#fff",
								border: "1px solid #e5e7eb",
								borderBottom: 0,
								borderRadius: "2px 2px 0 0",
								padding: "15px",
							}}
						>
							<Grid
								size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
								sx={{ mt: "12px" }}
							>
								<EnhancedDropDownRHF
									selectName="remittanceFrequencyId"
									testId={`remittanceFrequency-list`}
									items={updatedRemittanceFrequencyDDL && sortDDLByLabel(updatedRemittanceFrequencyDDL ?? [])}
									// selectedItem={remittanceFrequencyDDL && remittanceFrequencyDDL[0].value}
									showEmpty
									selectedItem={null}
									onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
									isDisabled={ontarioEhtSetup && ontarioEhtSetup.items && ontarioEhtSetup.items.some((item: any) => item.status === 'Remitted') ? true : false}
								/>
								<EnhancedDropDownRHF
									selectName="managedBy"
									testId={`managed_by-list`}
									items={
										companyInformation && companyInformation.paymentSetup === 100 ?
											[{ label: "Self Managed", value: 200 }] :
											[
												{ label: "Managed by Simplepay", value: 100 },
												{ label: "Self Managed", value: 200 },
											]}
									isDisabled={companyInformation && companyInformation.paymentSetup === 100 ? true : false}
									selectedItem={200}
									onSelectionChangeHandler={onManagedByChangeHandler}
								/>
								{/* <EnhancedDropDownRHF
									selectName="premiums"
									testId={`premiums-list`}
									items={[]}
									// selectedItem={}
									// onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
								/> */}
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
							<Grid
								size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
								sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", }}
							>
								<RHookFormNumberFieldWithLabel
									id="exemptionAmount"
									testId={`exemptionAmount`}
									label={"Exemption Amount"}
									labelPosition={LabelPosition.Left}
									labelColumns={6}
									fieldColumns={6}
								// defaultValue={1000000}
								/>
								<RHookFormNumberFieldWithLabel
									id="totalGrossPaidInYear"
									testId={`totalGrossPaidInYear`}
									label={`Total ON Gross Paid in ${taxYear - 1}`}
									labelPosition={LabelPosition.Left}
									labelColumns={6}
									fieldColumns={6}
								/>
								<EnhancedDropDownRHFWithLabel
									selectName="associatedEmployers"
									testId={`associatedEmployers`}
									items={[
										{ label: "No", value: false },
										{ label: "Yes", value: true },
									]}
									selectedItem={false}
									label="Associated Employers"
									labelPosition={LabelPosition.Left}
									labelColumns={6}
									fieldColumns={6}
								/>
								<div style={{ textAlign: "end" }}>
									<EnhancedButtonPrimeReact
										label="Save"
										// type="submit"
										// icon="pi pi-check"
										style={{ marginBottom: "1rem" }}
										raised
										severity={EnhancedButtonPrimeReactSeverity.Success}
										onClickHandler={onSaveButtonClickedHandler}
									/>
								</div>
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 4.4, lg: 4.4, xl: 4.4 }}></Grid>
							<Grid
								size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
								sx={{
									textAlign: "right",
									color: "rgba(0, 0, 0, 0.6)",
									fontSize: "0.875rem",
								}}
							>
								EHT Business No. TE <br />
								EHT Rate <span style={{ fontWeight: "bold" }}>400.00</span>
								<br />
								Find out more at Min of Fin EHT site <br />
								<Link
									to={`http://www.fin.gov.on.ca/en/guides/eht/`}
									className="no-underline"
									style={{ color: theme.palette.primary.light }}
								>
									http://www.fin.gov.on.ca/en/guides/eht/
								</Link>
								<br />
								{/* Export to excel */}
								<Link
									to={"#"}
									className="no-underline"
									onClick={onExportButtonClick}
								>
									<span style={{ color: theme.palette.primary.light }}>Export to Excel</span> <br />
								</Link>
							</Grid>
						</Grid>
					</form>
				</FormProvider>
				{managedBy !== 100 ? (
					<OntarioEhtDataGrid
						columns={ontarioEhtSetup ? ontarioEhtSetup.headerColumns : []}
						rows={
							ontarioEhtSetup && upadtedOntarioEhtSetupItems
								? upadtedOntarioEhtSetupItems
								: []
						}
						showIndexColumn={true}
						showChecboxColumn={isAdminUser === 400 ? true : false}
						// showSettingColumn={true}
						// onRowEditClicked={onRowEditClicked}
						onRowDeleteClicked={onRowDeleteClicked}
						onSnackbarMessageData={(value: any) => setSnackbarData(value)}
						totalRecords={
							ontarioEhtSetup && ontarioEhtSetup.total
								? ontarioEhtSetup.total
								: 0
						}
						initialPageSize={INITIAL_PAGE_SIZE}
						rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
						onRequestParamsChange={onRequestParamsChange}
						selectionToolbar={selectionToolbar}
						selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
						searchFieldPlaceholder={"Search..."}
						changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
							setzeroOntarioEht(value)
						}
						pageTitle={"OntarioEht"}
						ontarioEhtSetupTableData={(data: any) =>
							setOntarioEhtSetupTableData(data)
						}
						tableMargin={"0"}
					/>
				) : (
					<OntarioEhtDataGridWithManagedBySimplePay
						columns={ontarioEhtSetup ? ontarioEhtSetup.headerColumns : []}
						rows={
							ontarioEhtSetup && upadtedOntarioEhtSetupItems
								? upadtedOntarioEhtSetupItems
								: []
						}
						showIndexColumn={true}
						tableMargin={"0"}
					/>
				)}

				{ontarioEhtSetup && ontarioEhtSetup.items && managedBy === 200 && (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							// backgroundColor: "#fff",
							backgroundColor: "#F7F7F7",
							// marginTop: theme.spacing(3),
							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					>
						<Toolbar>
							<EnhancedButtonPrimeReact
								label="Submit"
								// type="submit"
								onClickHandler={onSubmitButtonClickedHandler}
								// icon="pi pi-check"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						</Toolbar>
					</AppBar>
				)}
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
